import { getDictionaryFromCDA } from './connector';
import { ActionKey, getDefaultActionValue } from './groups/ActionItems';
import { AuthenticationKey, getDefaultAuthenticationValue } from './groups/AuthenticationItems';
import { getDefaultPreviewValue, PreviewKey } from './groups/PreviewItems';
import { getDefaultSearchValue, SearchKey } from './groups/SearchItems';

export const defaultDictionaryValueMissing = 'Default dictionary value missing for';
export interface DictionaryInterface {
	getAction(key: ActionKey): string;
	getAuthentication(key: AuthenticationKey, replacements?: string[]): string;
	getPreview(key: PreviewKey): string;
	getSearch(key: SearchKey, replacements?: string[]): string;
}

export const DictionaryFactory = (dictionary: Dictionary.Items): DictionaryInterface => {
	const getValue = ({
		group,
		key,
		defaultValue,
		replacements,
	}: {
		group: 'Action' | 'Authentication' | 'Preview' | 'Search';
		key: string;
		defaultValue: string;
		replacements?: string[];
	}): string => {
		const dictionaryFromCms = dictionary.items.find(
			(item) => item?.key.toLocaleLowerCase() === `${group.toLocaleLowerCase()}.${key.toLocaleLowerCase()}`,
		)?.value;
		const dictionaryValue = dictionaryFromCms ? dictionaryFromCms : defaultValue;
		if (!replacements) return dictionaryValue;
		replacements.forEach((replacement, index) => {
			return dictionaryValue.replace(`{value${index + 1}}`, replacement);
		});
		return dictionaryValue;
	};
	return {
		getAction: (key: ActionKey) => getValue({ group: 'Action', key, defaultValue: getDefaultActionValue(key) }),
		getAuthentication: (key: AuthenticationKey) => getValue({ group: 'Authentication', key, defaultValue: getDefaultAuthenticationValue(key) }),
		getPreview: (key: PreviewKey) => getValue({ group: 'Preview', key, defaultValue: getDefaultPreviewValue(key) }),
		getSearch: (key: SearchKey, replacements?: string[]) =>
			getValue({ group: 'Search', key, defaultValue: getDefaultSearchValue(key), replacements }),
	};
};

export interface getDictionaryItemsProps {
	preview?: boolean;
}
export const getDictionaryItems = async ({ preview }: getDictionaryItemsProps): Promise<Dictionary.Items> => {
	return await getDictionaryFromCDA(preview);
};
